import React from "react"
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import { CustomInput, Button } from 'reactstrap'
import SearchIcon from "../../../static/images/search_icon.svg"
import { FONTS } from '../../../constants'
import shortid from 'shortid'
import * as CONSTANTS from '../../employee/constants'
/* eslint no-underscore-dangle: 0 */
export default class SearchBarEmployee extends React.Component {
  state={ tempSearch: '' }

  shouldComponentUpdate(nextProps, nextState) {
    
    
    if (nextState.tempSearch === this.state.tempSearch
      && get(nextProps, 'start_date') === get(this.props, 'start_date')
      && get(nextProps, 'end_date') === get(this.props, 'end_dae')
      && get(nextProps, 'selectedCompany') === get(this.props, 'selectedCompany')
      && get(nextProps, 'selectedLOB') === get(this.props, 'selectedLOB')
      && get(nextProps, 'selectedLeaveType') === get(this.props, 'selectedLeaveType')
      && get(nextProps, 'selectedStatus') === get(this.props, 'selectedStatus')
    ) return false
    return true
  }
  handleChange = (e) => {
    if (e.target.type === 'checkbox') {
      this.setState({ user: { ...this.state.user, [e.target.name]: e.target.checked } })
    } else this.setState({ user: { ...this.state.user, [e.target.name]: e.target.value } })
  }
  render() {
    
    return (
      <Wrapper>
        <WrapperButton>
          <Col>
            <SearchField
              placeholder={ 'Search By Name, ID' }
              value={ this.state.tempSearch }
              onChange={ (e) => {
                if (e.target.value === '') {
                  this.props.handleSearch('search', e.target.value)
                }
                this.setState({ tempSearch: e.target.value })
              } }
              onKeyDown={ (e) => {
                
                if (e.keyCode === 13) {
                  this.props.handleSearch(e.target.value)
                }
              } }
            />
          </Col>
          {/* <Col>
            <Text>Selected</Text>
            <center>(0)</center>
          </Col> */}
          <Col>
            <Text>Type:</Text>
            <CustomInputField
              id='selectedType'
              type="select"
              value={ get(this.props, 'selectedType') }
              onChange={ (e) => this.props.handleInputType('search', e) }
            >
               <option key={ 'All' } value={ '' }>All</option>
              { CONSTANTS.employee.map((g) => (
                          <option key={ shortid() } value={ g }>{ g }</option>
                        )) }
            </CustomInputField>
          </Col>
          <Col>
            <Text>LOB:</Text>
            <CustomInputField
              id='selectedLOB'
              type="select"
              value={ get(this.props, 'selectedLOB') }
              onChange={ (e) => this.props.handleInputLOB('search', e) }
            >
              <option key={ 'All' } value={ '' }>All</option>
              { get(this.props, 'lobs')
              && get(this.props, 'lobs').map(g => {
                return <option key={ g._id } value={ g.name === 'LOB' ? '' : g.name }>{ g.name }</option>
              })
              }
            </CustomInputField>
          </Col>
          <Col>
           
          <Button color="secondary" onClick= { (e) => this.props.handleClickNone()}>Reset</Button>
          </Col>
          <Col>
           
          <Button color="secondary" onClick= { () => this.props.handleClickAll()  }>Select All</Button>
           </Col>
        </WrapperButton>
      </Wrapper>
    )
  }
}

SearchBarEmployee.propTypes = {
  handleSearch: PropTypes.func,
  handleChangeStartDate: PropTypes.func,
  handleChangeEndDate: PropTypes.func,
  export: PropTypes.func,
}
SearchBarEmployee.defaultProps = {
  handleSearch: () => {},
  handleChangeStartDate: () => {},
  handleChangeEndDate: () => {},
  export: () => {},
}

const Col = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
`
const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1%;
  margin-right: 1%;
`
const SearchField = styled.input`
  height: 30px;
  width: 200px;
  padding-left: 30px;
  margin-top: 20px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 60px;
  position: relative;
  width: 100%;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  height: 30px;
`
const Text = styled.span`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/consent-management/search-bar/search-employee.js